import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class CheckoutConfirm extends BasePage {
    public static async init() {
        await super.init();

        this.setGTagDataLayers();
        this.setAnalyticsEvent();
        this.setFacebookEvent();
    }

    private static setGTagDataLayers() {
        var itemList = [];

        for (var i = 0; i < (<any>window).App.bag.order.OrderRows.length; i++) {
            itemList.push({
                item_id: (<any>window).App.bag.order.OrderRows[i].ProductCode,
                item_name: (<any>window).App.bag.order.OrderRows[i].ProductName,
                affiliation: "IloveOstrica",
                item_category: (<any>window).App.bag.order.OrderRows[i].CategoryName,
                coupon: (<any>window).App.bag.order.CouponCode,
                currency: "EUR",
                price: (<any>window).App.bag.order.OrderRows[i].UnitPrice,
                quantity: (<any>window).App.bag.order.OrderRows[i].Quantity
            });
        }

        (<any>window).dataLayer = (<any>window).dataLayer || [];
        (<any>window).dataLayer.push({ ecommerce: null });
        (<any>window).dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: (<any>window).App.bag.order.OrderCode,
                value: (<any>window).App.bag.order.OrderTotal,
                shipping: (<any>window).App.bag.order.ShippingCosts,
                currency: "EUR",
                coupon: (<any>window).App.bag.order.CouponCode,
                items: itemList
            }
        });
    }

    private static setAnalyticsEvent() {
        var itemList = [];

        for (var i = 0; i < (<any>window).App.bag.order.OrderRows.length; i++) {
            itemList.push({
                item_id: (<any>window).App.bag.order.OrderRows[i].ProductCode,
                item_name: (<any>window).App.bag.order.OrderRows[i].ProductName,
                affiliation: "IloveOstrica",
                item_category: (<any>window).App.bag.order.OrderRows[i].CategoryName,
                price: (<any>window).App.bag.order.OrderRows[i].UnitPrice,
                quantity: (<any>window).App.bag.order.OrderRows[i].Quantity
            });
        }

        GTagHelper.sendEvent("purchase", {
            currency: "EUR",
            transaction_id: (<any>window).App.bag.order.OrderCode,
            value: (<any>window).App.bag.order.OrderTotal,
            coupon: (<any>window).App.bag.order.CouponCode,
            shipping: (<any>window).App.bag.order.ShippingCosts,
            items: itemList
        });
    }

    private static setFacebookEvent() {
        if ((<any>window).fbq) {
            var contentType = "product",
                contentIDs = [],
                contents = [],
                currency = "EUR",
                value = (<any>window).App.bag.order.OrderTotal;

            for (var i = 0; i < (<any>window).App.bag.order.OrderRows.length; i++) {
                contentIDs.push((<any>window).App.bag.order.OrderRows[i].ProductCode);
                contents.push({ id: (<any>window).App.bag.order.OrderRows[i].ProductCode, quantity: (<any>window).App.bag.order.OrderRows[i].Quantity, item_price: (<any>window).App.bag.order.OrderRows[i].UnitPrice });
            }

            (<any>window).fbq("track", "Purchase", { content_type: contentType, content_ids: contentIDs, contents: contents, currency: currency, value: value });
        }
    }
}